import { gsap } from 'gsap';
import { Draggable } from 'gsap/Draggable';

export default class DraggableNav {
  constructor() {
    // capture main and nav references
    this.main = document.getElementById('main');
    this.nav = document.querySelector('.ann-nav');
    this.navCollection = document.querySelectorAll('.ann-nav a');
    this.navCell = document.querySelector('.ann-nav .cell');

    // nav width
    this.dragMinX = 0;
  }

  init() {
    if (this.main && this.navCell) {
      // update drag boundaries for mobile nav
      this.updateDragX(this.navCell.offsetWidth, window.innerWidth);

      // init app
      this.initGsap();
      this.initNavScroll();
      this.addResizeListener();
    }
  }

  initGsap() {
    gsap.registerPlugin(Draggable);

    Draggable.create('.ann-nav .cell', {
      type: 'x',
      bounds: {
        minX: this.dragMinX,
        maxX: 0,
      },
    });
  }

  initNavScroll() {
    // on scroll update active nav items
    window.addEventListener('scroll', () => {
      this.handleScroll();
    });
  }

  handleScroll() {
    const top = window.pageYOffset || document.documentElement.scrollTop;

    // position sticky nav based on scroll position
    // console.log(this.main);
    if (this.main) {
      const mainOffset = this.main.offsetTop || 0;
      const navOffset = document.querySelector('.ann-nav-position').offsetTop || 0;
      this.checkStickyNav(top, mainOffset, navOffset);
    }
  }

  checkStickyNav(top, mainOffset, navPlaceholderOffset) {
    if (top > mainOffset + navPlaceholderOffset) {
      this.main.classList.add('sticky');
    } else {
      this.main.classList.remove('sticky');
    }
  }

  updateDragX(navWidth, windowWidth) {
    this.dragMinX = -(navWidth - windowWidth);
    if (this.dragMinX >= 0) {
      this.dragMinX = 0;
    }
  }

  addResizeListener() {
    // listen for window resize
    window.addEventListener('resize', () => {
      // update drag min
      this.updateDragX(this.navCell.offsetWidth, window.innerWidth);
      Draggable.get('.ann-nav .cell').applyBounds({ minX: this.dragMinX, maxX: 0 });
    });
  }
}



// WEBPACK FOOTER //
// /opt/jenkins_home/workspace/marketing-campaigns_deploy_trigger_bcom/package/src/js/draggableNav.js